module.exports = __webpack_public_path__ + "static/media/ic_template_9.4cb8e80f.png";